(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["riot-carousel-controls"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('riot-carousel')) {
    customElements.define('riot-carousel', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-carousel-track]');
        this.controls = this.querySelector('[data-carousel-controls]');
        if (!this.track || !this.controls) return;
        this.abort?.abort();
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.previous = this.querySelector('[data-carousel-prev]');
        this.next = this.querySelector('[data-carousel-next]');
        this.status = this.querySelector('[data-carousel-status]');
        this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
        this.previous.addEventListener('click', () => this.move(-1), options);
        this.next.addEventListener('click', () => this.move(1), options);
        this.track.addEventListener('scroll', () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => { this.frame = 0; this.update(); });
        }, { ...options, passive: true });
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track) return;
          const rtl = getComputedStyle(this.track).direction === 'rtl';
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.move((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
          } else if (event.key === 'Home' || event.key === 'End') {
            event.preventDefault();
            this.go(event.key === 'Home' ? 0 : this.track.scrollWidth);
          }
        }, options);
        this.resize = new ResizeObserver(() => this.update());
        this.resize.observe(this.track);
        this.update();
      }
      go(position) {
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        this.track.scrollTo({ left: position * (rtl ? -1 : 1), behavior: this.reducedMotion.matches ? 'instant' : 'smooth' });
      }
      move(direction) {
        const cards = this.track.children;
        if (!cards.length) return;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const step = cards[0].getBoundingClientRect().width + gap;
        const visible = Math.max(1, Math.floor((this.track.clientWidth + gap) / step));
        const position = Math.abs(this.track.scrollLeft);
        this.go(Math.max(0, Math.min(this.track.scrollWidth - this.track.clientWidth, position + direction * visible * step)));
      }
      update() {
        const max = this.track.scrollWidth - this.track.clientWidth;
        const position = Math.abs(this.track.scrollLeft);
        this.controls.hidden = max < 2;
        this.previous.disabled = position < 2;
        this.next.disabled = position >= max - 2;
        const cards = [...this.track.children];
        const bounds = this.track.getBoundingClientRect();
        const visible = cards.map((card, index) => ({ rect: card.getBoundingClientRect(), index }))
          .filter(({ rect }) => rect.right > bounds.left + 8 && rect.left < bounds.right - 8);
        if (visible.length) {
          const text = `${visible[0].index + 1}\u2013${visible[visible.length - 1].index + 1} / ${cards.length}`;
          if (this.status.textContent !== text) this.status.textContent = text;
        }
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.resize?.disconnect();
        cancelAnimationFrame(this.frame);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["riot-hero-video"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('riot-hero-video')) {
    customElements.define('riot-hero-video', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        this.button = this.querySelector('button');
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.visible = false;
        this.userPaused = false;
        this.manualPlayback = false;
        this.blocked = false;
        this.pending = null;
        this.video.muted = true;
        this.video.defaultMuted = true;
        this.video.playsInline = true;
        this.button.addEventListener('click', () => {
          if (this.video.paused) { this.userPaused = false; this.manualPlayback = true; this.start(); }
          else { this.userPaused = true; this.video.pause(); }
        }, options);
        this.video.addEventListener('playing', () => { this.blocked = false; this.updateButton(); }, options);
        this.video.addEventListener('pause', () => this.updateButton(), options);
        this.video.addEventListener('loadeddata', () => this.sync(), options);
        this.video.addEventListener('canplay', () => this.sync(), options);
        this.motion.addEventListener('change', () => { this.manualPlayback = false; this.sync(); }, options);
        document.addEventListener('visibilitychange', () => this.sync(), options);
        window.addEventListener('pageshow', () => this.sync(), options);
        window.addEventListener('load', () => this.sync(), options);
        const retryBlockedPlayback = () => { if (this.blocked) this.sync(); };
        document.addEventListener('pointerdown', retryBlockedPlayback, { ...options, passive: true });
        document.addEventListener('keydown', retryBlockedPlayback, options);
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting && entries[0].intersectionRatio > 0;
          this.sync();
        }, { threshold: 0.05 });
        this.observer.observe(this);
        this.updateButton();
      }
      updateButton() {
        const paused = this.video.paused;
        this.button.hidden = paused && !this.blocked && !this.userPaused && !this.motion.matches && !navigator.connection?.saveData;
        this.button.setAttribute('aria-label', paused ? this.button.dataset.playLabel : this.button.dataset.pauseLabel);
        this.button.firstElementChild.textContent = paused ? '▶' : 'Ⅱ';
      }
      start() {
        if (this.pending || !this.video.paused) return;
        const source = this.video.querySelector('source');
        this.video.muted = true;
        this.video.defaultMuted = true;
        if (!source.getAttribute('src') && source.dataset.src) {
          source.src = source.dataset.src;
          this.video.load();
        }
        this.pending = this.video.play()
          .then(() => { this.blocked = false; })
          .catch(error => { this.blocked = error.name === 'NotAllowedError'; })
          .finally(() => { this.pending = null; if (this.isConnected) this.updateButton(); });
      }
      sync() {
        const motionAllowed = this.manualPlayback || (!this.motion.matches && !navigator.connection?.saveData);
        if (this.visible && !document.hidden && !this.userPaused && motionAllowed) this.start();
        else this.video.pause();
        this.updateButton();
      }
      disconnectedCallback() { this.video.pause(); this.abort.abort(); this.observer.disconnect(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
